import { getStopName } from "./line-config.js";

export const NAME_REPLACEMENTS: { match: RegExp; replace: string }[] = [
  { match: /^Busto G\.\s*/, replace: "" },
  { match: /^Busto A\.\s*/, replace: "B.A. " },
  { match: /^Pregnana\s*/, replace: "Pregn. " },
  { match: /^Villa Cortese\s*/, replace: "V.C. " },
  { match: /^Villa C\.\s*/, replace: "V.C. " },
  { match: /^Castano P\.\s*/, replace: "Cast. " },
  { match: /^Milano\s*/, replace: "MI " },
  { match: /^Legnano\s*/, replace: "Legn. " },
  { match: /^Parabiago\s*/, replace: "Parab. " },
  { match: /^S\. Giorgio\s*/, replace: "S.G. " },
  { match: /^S\. Stefano\s*/, replace: "S.St. " },
  { match: /^Vighignolo\s*/, replace: "Vigh. " },
  { match: /^Settimo\s*/, replace: "Sett. " },
  { match: /^Rho\s*/, replace: "Rho " },
  { match: /^Nerviano\s*/, replace: "Nerv. " },
  { match: /^Cornaredo\s*/, replace: "Corn. " },
  { match: /^Magenta\s*/, replace: "Mag. " },
  { match: /^Corbetta\s*/, replace: "Corb. " },
  { match: /^Vittuone\s*/, replace: "Vitt. " },
  { match: /^Sedriano\s*/, replace: "Sedr. " },
  { match: /^Bareggio\s*/, replace: "Bar. " },
  { match: /^Canegrate\s*/, replace: "Can. " },
  { match: /^Cerro M\.\s*/, replace: "Cerro " },
  { match: /^Lainate\s*/, replace: "Lain. " },
  { match: /^Origgio\s*/, replace: "Orig. " },
  { match: /^Pogliano\s*/, replace: "Pogl. " },
  { match: /^Pero\s*/, replace: "Pero " },
  { match: /^Inveruno\s*/, replace: "Inv. " },
  { match: /^Cuggiono\s*/, replace: "Cugg. " },
  { match: /^Turbigo\s*/, replace: "Turb. " },
  { match: /^Bernate T\.\s*/, replace: "Bern. " },
  { match: /^Marcallo\s*/, replace: "Marc. " },
  { match: /^S\.V\. Olona\s*/, replace: "SVO " },
  { match: /^Vanzago\s*/, replace: "Vanz. " },
  { match: /^Arluno\s*/, replace: "Arl. " },
  { match: /^Ossona\s*/, replace: "Oss. " },
  { match: /^Casorezzo\s*/, replace: "Cas. " },
  { match: /^Dairago\s*/, replace: "Dair. " },
  { match: /^Arconate\s*/, replace: "Arc. " }
];

export const CITY_ABBREVIATIONS = new Map<string, { canonical: string; patterns: string[] }>([
  ["BT", { canonical: "B.G.", patterns: ["B.G.", "BG", "Busto Garolfo", "Busto G."] }],
  ["OC", { canonical: "B.G.", patterns: ["B.G.", "BG", "Busto Garolfo", "Busto G.", "Olcella"] }],
  ["VC", { canonical: "V.C.", patterns: ["V.C.", "VC", "Villa Cortese", "Villa C."] }],
  ["DG", { canonical: "Dair.", patterns: ["Dair.", "DG", "Dairago"] }],
  ["AC", { canonical: "Arc.", patterns: ["Arc.", "AC", "Arconate"] }],
  ["CZ", { canonical: "Cas.", patterns: ["Cas.", "CZ", "Casorezzo"] }],
  ["LG", { canonical: "Legn.", patterns: ["Legn.", "LG", "Legnano"] }],
  ["PB", { canonical: "Parab.", patterns: ["Parab.", "PB", "Parabiago"] }],
  ["VP", { canonical: "Parab.", patterns: ["Parab.", "VP", "Parabiago"] }],
  ["VS", { canonical: "Parab.", patterns: ["Parab.", "VS", "Parabiago"] }],
  ["BS", { canonical: "B.A.", patterns: ["B.A.", "BS", "Busto Arsizio", "Busto A."] }],
  ["AL", { canonical: "Arl.", patterns: ["Arl.", "AL", "Arluno"] }],
  ["RG", { canonical: "Arl.", patterns: ["Arl.", "RG", "Arluno", "Rogorotto"] }],
  ["BA", { canonical: "Bar.", patterns: ["Bar.", "BA", "Bareggio"] }],
  ["BC", { canonical: "Bus.", patterns: ["Bus.", "BC", "Buscate"] }],
  ["BE", { canonical: "Bern.", patterns: ["Bern.", "BE", "Bernate"] }],
  ["BF", { canonical: "Boff.", patterns: ["Boff.", "BF", "Boffalora"] }],
  ["BI", { canonical: "Magn.", patterns: ["Magn.", "BI", "Magnago"] }],
  ["MM", { canonical: "Magn.", patterns: ["Magn.", "MM", "Magnago"] }],
  ["BR", { canonical: "Lain.", patterns: ["Lain.", "BR", "Lainate", "Barbaiana"] }],
  ["LN", { canonical: "Lain.", patterns: ["Lain.", "LN", "Lainate"] }],
  ["CB", { canonical: "Corb.", patterns: ["Corb.", "CB", "Corbetta"] }],
  ["CD", { canonical: "Corn.", patterns: ["Corn.", "CD", "Cornaredo"] }],
  ["CG", { canonical: "Cugg.", patterns: ["Cugg.", "CG", "Cuggiono"] }],
  ["CL", { canonical: "Cerro", patterns: ["Cerro", "CL", "Cerro Maggiore", "Cantalupo"] }],
  ["CR", { canonical: "Cerro", patterns: ["Cerro", "CR", "Cerro Maggiore"] }],
  ["CN", { canonical: "Can.", patterns: ["Can.", "CN", "Canegrate"] }],
  ["CT", { canonical: "Cast.", patterns: ["Cast.", "CT", "Castano"] }],
  ["GB", { canonical: "Nerv.", patterns: ["Nerv.", "GB", "Nerviano", "Garbatola"] }],
  ["NR", { canonical: "Nerv.", patterns: ["Nerv.", "NR", "Nerviano"] }],
  ["SI", { canonical: "Nerv.", patterns: ["Nerv.", "SI", "Nerviano", "S. Ilario"] }],
  ["VL", { canonical: "Nerv.", patterns: ["Nerv.", "VL", "Nerviano"] }],
  ["IN", { canonical: "Inv.", patterns: ["Inv.", "IN", "Inveruno"] }],
  ["MC", { canonical: "Marc.", patterns: ["Marc.", "MC", "Marcallo"] }],
  ["MD", { canonical: "MI", patterns: ["MI", "MD", "Milano", "Molino Dorino"] }],
  ["ML", { canonical: "MI", patterns: ["MI", "ML", "Milano"] }],
  ["MG", { canonical: "Mag.", patterns: ["Mag.", "MG", "Magenta"] }],
  ["MN", { canonical: "Vanz.", patterns: ["Vanz.", "MN", "Vanzago", "Mantegazza"] }],
  ["VZ", { canonical: "Vanz.", patterns: ["Vanz.", "VZ", "Vanzago"] }],
  ["MS", { canonical: "Mesero", patterns: ["Mesero", "MS"] }],
  ["NS", { canonical: "Nosate", patterns: ["Nosate", "NS"] }],
  ["OR", { canonical: "Orig.", patterns: ["Orig.", "OR", "Origgio"] }],
  ["OS", { canonical: "Oss.", patterns: ["Oss.", "OS", "Ossona"] }],
  ["PG", { canonical: "Pregn.", patterns: ["Pregn.", "PG", "Pregnana"] }],
  ["PM", { canonical: "Pogl.", patterns: ["Pogl.", "PM", "Pogliano"] }],
  ["PR", { canonical: "Pero", patterns: ["Pero", "PR"] }],
  ["RB", { canonical: "Rob.", patterns: ["Rob.", "RB", "Robecchetto"] }],
  ["RH", { canonical: "Rho", patterns: ["Rho", "RH"] }],
  ["SD", { canonical: "Sedr.", patterns: ["Sedr.", "SD", "Sedriano"] }],
  ["SG", { canonical: "S.G.", patterns: ["S.G.", "SG", "S. Giorgio"] }],
  ["SV", { canonical: "SVO", patterns: ["SVO", "SV", "S.V. Olona"] }],
  ["TB", { canonical: "Turb.", patterns: ["Turb.", "TB", "Turbigo"] }],
  ["TI", { canonical: "S.St.", patterns: ["S.St.", "TI", "S. Stefano"] }],
  ["TM", { canonical: "Sett.", patterns: ["Sett.", "TM", "Settimo"] }],
  ["VH", { canonical: "Vigh.", patterns: ["Vigh.", "VH", "Vighignolo"] }],
  ["VT", { canonical: "Vitt.", patterns: ["Vitt.", "VT", "Vittuone"] }],
  ["VN", { canonical: "Vanzag.", patterns: ["Vanzag.", "VN", "Vanzaghello"] }]
]);

export function shortStop(code: string): string {
  let name = getStopName(code);
  if (!name) return code;

  for (const { match, replace } of NAME_REPLACEMENTS) {
    name = name.replace(match, replace);
  }

  if (code && typeof code === "string") {
    const prefix = code.substring(0, 2).toUpperCase();
    const cityInfo = CITY_ABBREVIATIONS.get(prefix);
    if (cityInfo) {
      const lowerName = name.toLowerCase();
      const alreadyHasAcronym = cityInfo.patterns.some((pattern) => {
        const lowerPattern = pattern.toLowerCase();
        return lowerName.startsWith(lowerPattern) || lowerName.includes(lowerPattern);
      });

      if (!alreadyHasAcronym) {
        name = `${cityInfo.canonical} ${name}`;
      }
    }
  }

  return name;
}
